module.exports = __webpack_public_path__ + "static/media/main-business-04.a6c1468.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/assets/video/main-business-04.mp4
// module id = 7gzY
// module chunks = 1